// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Vs-z","giftOrPromoSelector":"Ws-z","disabled":"Xs-z","subTitle":"Ys-z","selectShipAddressMessage":"Zs-z","changePayment":"_s-z"};